import {Injectable} from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import {Observable} from 'rxjs';

import {environment} from '@env/environment';

/**
 * Prefixes relative request paths with `environment.serverUrl`.
 *
 * Only genuinely relative URLs are prefixed. Anything carrying a scheme is
 * passed through untouched — on iOS the Capacitor WebView origin is
 * `capacitor://…` (see providers/olo-auth-base-url.ts), and blindly prefixing
 * that produced URLs like `/apicapacitor://order.punchpizza.com/oloauth/refresh`.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiPrefixInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!/^[a-z][a-z0-9.+-]*:/i.test(request.url)) {
      request = request.clone({url: environment.serverUrl + request.url});
    }
    return next.handle(request);
  }
}
